module.exports = __webpack_public_path__ + "img/202502120102.2fc92caa.png";